import React, { PropsWithChildren, createContext } from 'react';
import { DialogProvider } from './dialog';
import { GlobalDialog } from 'components/molecules';

export const AppContext = createContext({});

export const AppContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const appState = {};

  return (
    <AppContext.Provider value={appState}>
      <DialogProvider>
        {children}

        <GlobalDialog />
      </DialogProvider>
    </AppContext.Provider>
  );
};
